import { createReducer, on } from '@ngrx/store';
import { GlobalState, initialGlobalState } from './global.state';
import * as GlobalActions from './global.actions';

export const globalReducer = createReducer(
    initialGlobalState,

    // Loading Management
    on(GlobalActions.startLoading, (state, { actionType }) => ({
        ...state,
        loadingActions: new Set(state.loadingActions).add(actionType)
    })),

    on(GlobalActions.stopLoading, (state, { actionType }) => {
        const newLoadingActions = new Set(state.loadingActions);
        newLoadingActions.delete(actionType);
        return {
            ...state,
            loadingActions: newLoadingActions
        };
    }),

    on(GlobalActions.clearAllLoading, (state) => ({
        ...state,
        loadingActions: new Set<string>()
    })),

    // Error Management
    on(GlobalActions.setGlobalError, (state, { error }) => ({
        ...state,
        error
    })),

    on(GlobalActions.clearGlobalError, (state) => ({
        ...state,
        error: null
    }))
);
